import mod from "-!./GetStarted.js?vue&type=script&lang=js&"; export default mod; export * from "-!./GetStarted.js?vue&type=script&lang=js&"